import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  SimpleGrid,
  Image,
  Text,
  useDisclosure,
  Flex,
  Icon,
  Badge,
} from "@chakra-ui/react";
import { AddIcon } from "@chakra-ui/icons";
import { supabase } from "../../lib/supabaseClient";
import { useAuth } from "../../context/AuthContext";
import MusicianModal from "../modals/MusicianModal";

const MusicianTab = () => {
  const { user } = useAuth();
  const [musicians, setMusicians] = useState([]);
  const {
    isOpen: isMusicianModalOpen,
    onOpen: onMusicianModalOpen,
    onClose: onMusicianModalClose,
  } = useDisclosure();

  // 뮤지션 데이터 가져오기
  useEffect(() => {
    const fetchMusicians = async () => {
      const { data, error } = await supabase
        .from("musician")
        .select("image_profile, name_musician, debut_nation, language")
        .eq("user", user.email)
        .order("created_date", { ascending: false });

      if (error) {
        console.error("Error fetching musicians:", error);
        return;
      }
      setMusicians(data);
    };

    if (user) fetchMusicians();
  }, [user]);

  // 뮤지션 데이터 새로고침 함수
  const refreshMusicians = async () => {
    if (!user) return;

    const { data, error } = await supabase
      .from("musician")
      .select("image_profile, name_musician, debut_nation, language")
      .eq("user", user.email)
      .order("created_date", { ascending: false });

    if (error) {
      console.error("Error fetching musicians:", error);
      return;
    }
    setMusicians(data);
  };

  return (
    <>
      <SimpleGrid columns={[1, 2, 3, 4]} spacing={6} p={4}>
        <Box
          as={Button}
          variant="outline"
          height="300px"
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          borderWidth="2px"
          borderStyle="dashed"
          borderRadius="xl"
          borderColor="blue.200"
          _hover={{
            borderColor: "blue.400",
            bg: "blue.50",
            transform: "scale(1.02)",
            transition: "all 0.2s",
          }}
          onClick={onMusicianModalOpen}
        >
          <Icon as={AddIcon} boxSize={8} color="blue.400" mb={2} />
          <Text color="blue.600" fontWeight="medium">
            새 뮤지션 추가
          </Text>
        </Box>

        {musicians.map((musician, index) => (
          <Box
            key={index}
            height="300px"
            borderWidth="1px"
            borderRadius="xl"
            overflow="hidden"
            position="relative"
            bg="white"
            boxShadow="md"
            _hover={{
              boxShadow: "lg",
              transform: "translateY(-4px)",
              transition: "all 0.2s",
            }}
          >
            <Box height="200px" position="relative" overflow="hidden">
              <Image
                src={musician.image_profile}
                alt={musician.name_musician}
                objectFit="contain"
                height="100%"
                width="100%"
                bg="gray.50"
                fallback={
                  <Box
                    height="100%"
                    width="100%"
                    bg="gray.100"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Text color="gray.400">이미지 없음</Text>
                  </Box>
                }
              />
            </Box>

            <Box p={4}>
              <Text
                fontSize="xl"
                fontWeight="bold"
                color="gray.700"
                mb={2}
                noOfLines={1}
              >
                {musician.name_musician}
              </Text>
              <Flex gap={2} mb={2}>
                {musician.debut_nation && (
                  <Badge colorScheme="blue" borderRadius="full" px={2}>
                    {musician.debut_nation}
                  </Badge>
                )}
                {musician.language && (
                  <Badge colorScheme="purple" borderRadius="full" px={2}>
                    {musician.language}
                  </Badge>
                )}
              </Flex>
            </Box>
          </Box>
        ))}
      </SimpleGrid>

      <MusicianModal
        isOpen={isMusicianModalOpen}
        onClose={onMusicianModalClose}
        onSuccess={refreshMusicians}
      />
    </>
  );
};

export default MusicianTab;
